export default "__VITE_ASSET__DuoxMQlp__"